// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__VYT76","imglogo":"Admin_imglogo__+dLAh","info":"Admin_info__SJzCQ","form":"Admin_form__ABydG","search":"Admin_search__PB6CF"};